import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './utils/startup'
import VueAnalytics from 'vue-analytics';

Vue.config.productionTip = false;

Vue.use(VueAnalytics, {
  id: 'UA-28538578-4',
  router
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
